import request from '@/service/http'
import { userInfoRes } from '../type/userInfo'

export function getUserInfoApi(): Promise<userInfoRes> {
  return request<userInfoRes>({
    url: '/api/user/info',
    method: 'get',
  })
}
